import { useEffect, useState } from 'react'
import type { TrackReferenceOrPlaceholder } from '@livekit/components-core'

/**
 * Hook to check if participant's microphone is blocked by admin
 */
export function useMicrophoneBlocked(trackRef: TrackReferenceOrPlaceholder): boolean {
  const [isMicrophoneBlocked, setIsMicrophoneBlocked] = useState<boolean>(false)

  useEffect(() => {
    const canPublishSources = trackRef.participant.permissions?.canPublishSources
    const isBlocked =
      !trackRef.participant.isLocal &&
      !trackRef.participant.permissions?.agent &&
      trackRef.participant.permissions?.canPublish &&
      !!canPublishSources?.length &&
      !canPublishSources.includes(2)

    setIsMicrophoneBlocked(isBlocked || false)
  }, [
    trackRef.participant.isLocal,
    trackRef.participant.permissions?.agent,
    trackRef.participant.permissions?.canPublish,
    trackRef.participant.permissions?.canPublishSources,
  ])

  return isMicrophoneBlocked
}


